/* ============================================================
   Floating Subscribe Popup
   File: assets/newsletter-popup.js
   ============================================================ */

(function () {
  'use strict';

  /* ==========================================================
     Find Current Section
     ========================================================== */

  function initNewsletterPopup(container) {
    if (!container) {
      return;
    }
    /* ========================================================
       Elements
       ======================================================== */
    var floatingButton = container.querySelector('.fs-floating-button');
    var popupWrapper = container.querySelector('.fs-popup-wrapper');
    var overlay = container.querySelector('.fs-overlay');
    var closeButtons = container.querySelectorAll('[data-fs-close]');
    var messageWrapper = container.querySelector('[data-fs-message-wrapper]');
    var successMessage = container.querySelector('[data-fs-success]');
    var errorMessage = container.querySelector('[data-fs-error]');
    var messageCloseButtons = container.querySelectorAll('[data-fs-message-close]');
    var form = container.querySelector('.fs-form');
    var submitButton = container.querySelector('.fs-submit');
    /* ========================================================
       Open Popup
       ======================================================== */
    function openPopup() {
      if (!popupWrapper) {
        return;
      }
      popupWrapper.classList.add('is-open');
      if (overlay) {
        overlay.classList.add('is-open');
      }
      if (floatingButton) {
        floatingButton.setAttribute(
          'aria-expanded',
          'true'
        );
      }
      document.body.classList.add(
        'fs-subscribe-no-scroll'
      );
      setTimeout(function () {
        var input = container.querySelector('.fs-input');
        if (input) {
          input.focus();
        }
      }, 250);
    }
    /* ========================================================
       Close Popup
       ======================================================== */
    function closePopup() {
      if (!popupWrapper) {
        return;
      }
      popupWrapper.classList.remove('is-open');
      if (overlay) {
        overlay.classList.remove('is-open');
      }
      if (floatingButton) {
        floatingButton.setAttribute(
          'aria-expanded',
          'false'
        );
      }
      if (
        !messageWrapper ||
        !messageWrapper.classList.contains('is-open')
      ) {
        document.body.classList.remove(
          'fs-subscribe-no-scroll'
        );
      }
    }
    /* ========================================================
       Show Success Message
       ======================================================== */
    function showSuccessMessage() {
      closePopup();
      if (errorMessage) {
        errorMessage.style.display = 'none';
      }
      if (successMessage) {
        successMessage.style.display = 'block';
      }
      if (messageWrapper) {
        messageWrapper.classList.add('is-open');
      }
      document.body.classList.add(
        'fs-subscribe-no-scroll'
      );
    }
    /* ========================================================
       Show Error Message
       ======================================================== */
    function showErrorMessage() {
      closePopup();
      if (successMessage) {
        successMessage.style.display = 'none';
      }
      if (errorMessage) {
        errorMessage.style.display = 'block';
      }
      if (messageWrapper) {
        messageWrapper.classList.add('is-open');
      }
      document.body.classList.add(
        'fs-subscribe-no-scroll'
      );
    }
    /* ========================================================
       Close Message
       ======================================================== */

    function closeMessage() {
      if (messageWrapper) {
        messageWrapper.classList.remove('is-open');
      }
      document.body.classList.remove(
        'fs-subscribe-no-scroll'
      );
    }
    /* ========================================================
       Floating Button
       ======================================================== */
    if (floatingButton) {
      floatingButton.addEventListener(
        'click',
        function () {

          openPopup();

        }
      );
    }
    /* ========================================================
       Close Popup Buttons
       ======================================================== */
    if (closeButtons.length) {
      closeButtons.forEach(
        function (button) {
          button.addEventListener(
            'click',
            function () {
              closePopup();
            }
          );
        }
      );
    }
    /* ========================================================
       Message Close Buttons
       ======================================================== */
    if (messageCloseButtons.length) {
      messageCloseButtons.forEach(
        function (button) {
          button.addEventListener(
            'click',
            function () {

              closeMessage();

            }
          );
        }
      );
    }
    /* ========================================================
       ESC Key
       ======================================================== */
    document.addEventListener(
      'keydown',
      function (event) {
        if (event.key !== 'Escape') {
          return;
        }
        if (
          popupWrapper &&
          popupWrapper.classList.contains('is-open')
        ) {
          closePopup();
          return;
        }
        if (
          messageWrapper &&
          messageWrapper.classList.contains('is-open')
        ) {
          closeMessage();
        }
      }
    );
    /* ========================================================
       Submit Loading
       ======================================================== */
    if (form) {
      form.addEventListener(
        'submit',
        function () {
          if (submitButton) {
            submitButton.disabled = true;
            submitButton.classList.add(
              'is-loading'
            );
          }
        }
      );
    }
    /* ========================================================
       Shopify Customer Form Result
       ======================================================== */
    try {
      var currentUrl = new URL(window.location.href);
      var customerPosted =
        currentUrl.searchParams.get(
          'customer_posted'
        );
      /* ======================================================
         Successful Subscription
         ====================================================== */
      if (customerPosted === 'true') {
        /*
          Shopify 提交成功以后可能出现：
          ?customer_posted=true#contact_form
          或：
          ?customer_posted=true
        */
        /*
          立即回到顶部
        */
        window.scrollTo(0, 0);
        /*
          清除：
          customer_posted=true
          #contact_form

          保留其他正常 query 参数
        */
        currentUrl.searchParams.delete(
          'customer_posted'
        );
        currentUrl.hash = '';
        if (
          window.history &&
          window.history.replaceState
        ) {
          window.history.replaceState(
            {},
            document.title,
            currentUrl.pathname +
            currentUrl.search
          );
        }
        /*
          再执行一次顶部定位，
          防止浏览器恢复提交前的位置
        */
        setTimeout(
          function () {
            window.scrollTo(0, 0);
          },
          0
        );
        setTimeout(
          function () {
            window.scrollTo(0, 0);
          },
          50
        );
        /*
          延迟显示成功消息
        */
        setTimeout(
          function () {
            showSuccessMessage();
          },
          200
        );
      }
      /* ======================================================
         Shopify Form Error
         ====================================================== */
      var formErrors =
        container.querySelector(
          '.fs-form-errors'
        );
      if (
        formErrors &&
        formErrors.textContent.trim() !== ''
      ) {
        setTimeout(
          function () {
            showErrorMessage();
          },
          200
        );
      }
    } catch (error) {
      console.log(
        'Floating Subscribe:',
        error
      );
    }
  }
  /* ==========================================================
     Remove Shopify Customer Form Anchor
     ========================================================== */
  function cleanCustomerFormHash() {
    try {
      var currentUrl = new URL(window.location.href);
      if (
        currentUrl.hash === '#contact_form'
      ) {
        currentUrl.hash = '';
        if (
          window.history &&
          window.history.replaceState
        ) {
          window.history.replaceState(
            {},
            document.title,
            currentUrl.pathname +
            currentUrl.search
          );
        }
        window.scrollTo(0, 0);
      }
    } catch (error) {
      console.log(
        'Floating Subscribe anchor cleanup:',
        error
      );
    }
  }
  /* ==========================================================
     Initialize All Existing Sections
     ========================================================== */

  function initAll() {
    cleanCustomerFormHash();
    var containers = document.querySelectorAll( '.fs-container' );
    if (!containers.length) {
      return;
    }
    containers.forEach(
      function (container) {
        if (
          container.dataset.fsInitialized === 'true'
        ) {
          return;
        }
        container.dataset.fsInitialized = 'true';
        initNewsletterPopup(container);
      }
    );
  }
  /* ==========================================================
     DOM Ready
     ========================================================== */
  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initAll
    );
  } else {
    initAll();
  }
  /* ==========================================================
     Shopify Theme Editor Support
     ========================================================== */
  document.addEventListener(
    'shopify:section:load',
    function (event) {
      if (
        !event.detail ||
        !event.detail.sectionId
      ) {
        return;
      }
      var container = document.getElementById( 'floating-subscribe-' + event.detail.sectionId );
      if (!container) {
        return;
      }
      if (
        container.dataset.fsInitialized === 'true'
      ) {
        return;
      }
      container.dataset.fsInitialized = 'true';
      initNewsletterPopup(container);
    }
  );
  /* ==========================================================
     Shopify Theme Editor Unload
     ========================================================== */
  document.addEventListener(
    'shopify:section:unload',
    function (event) {
      if (
        event.detail &&
        event.detail.sectionId
      ) {
        document.body.classList.remove(
          'fs-subscribe-no-scroll'
        );
      }
    }
  );
})();